import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50b19c1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["contenteditable", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.theme, { 'show-scrollbar': _ctx.isHovered }]),
    contenteditable: _ctx.contenteditable,
    placeholder: "点此编辑笔记内容",
    ref: "divedit",
    key: _ctx.key,
    innerHTML: _ctx.content,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputcontent && _ctx.inputcontent(...args))),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isBlur = true)),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isBlur = false)),
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stockclick && _ctx.stockclick(...args))),
    onPaste: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
    onDrop: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
    onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isHovered = true)),
    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isHovered = false))
  }, null, 42, _hoisted_1))
}